import React, { useMemo } from 'react';
import './KodanshaWheelItem.scss';
import { useHistory } from 'react-router-dom';
import { Link } from '../../Devon/Components/InkyLink';
import { DiscoverItem } from '../../Models/DiscoverItem';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import { readerReadableUrlOrDefault } from '../../utils/utils';

interface KodanshaWheelItemProps {
    title: string;
    product: DiscoverItem;
    cta: any;
    // to allow the same ration for mixed product/series wheels and grids
    ratio?: number;
}

function KodanshaWheelItem(props: KodanshaWheelItemProps): JSX.Element {
    const history = useHistory();

    let imageClass = 'Item-Thumbnail-Series';
    let innerBorderClass = 'InnerBorder';

    // const item = useRef(null);
    // useRatio(item, 1.5, 1400);

    if (props.product.type === 'product') {
        imageClass = 'Item-Thumbnail-Product';
        innerBorderClass = 'InnerBorder-Product';
    }

    function navigateToProductPageForLink(): string {
        if (props.product.type === 'product' && (props.product.content.id !== null && props.product.content.readableUrl !== null)) {
            return '/product/' + (props.product.content.readableUrl ?? props.product.content.id);
        }
        if (props.product.type === 'series' && (props.product.content.id !== null && props.product.content.readableUrl !== null)) {
            return '/series/' + (props.product.content.readableUrl ?? props.product.content.id);
        }
    }

    // console.log('props.cta', props.cta);
    function getTitle(item: DiscoverItem): string {
        let title = item?.content?.seriesName;
        let number = '';
        if (item.displayType === 'Chapter' && item.content?.chapterNumber !== undefined) {
            number = item?.content?.chapterNumber?.toString();
            title += ', ' + item?.displayType + ' ' + number;
        } else if (item.displayType === 'Volume' && item.content.volumeName !== undefined && item.content?.volumeName !== '') {
            number = item?.content?.volumeNumber?.toString();
            title += ', ' + item.content.volumeName;
        } else if (item.displayType === 'Volume' && item.content?.volumeNumber !== undefined) {
            number = item?.content?.volumeNumber?.toString();
            title += ', ' + item?.displayType + ' ' + number;
        } else {
            title = item?.content?.title;
        }

        return title;
    }

    const linkTo = useMemo(() => navigateToProductPageForLink(), [props.product]);

    function getProductPoster(): JSX.Element {
        if (props.product.type === 'product') {
            return (
                <ProductPoster
                    preloadImage={false}
                    ratio={props.ratio ?? 125}
                    isOnSale={props.product.content?.variants && props.product.content?.variants[0]?.isOnSale}
                    src={props.product.content.thumbnails[0]?.url}
                    hover={!!linkTo} alt={'product cover for ' + props.product.content.title + ' from kodansha'}
                />
            );
        }

        // Returns series as default
        return (
            <SeriesPoster
                preloadImage={false}
                ratio={props.ratio ?? 140}
                src={props.product.content.thumbnails[0]?.url}
                color={props.product.content.thumbnails[0]?.color}
                alt={'series cover for ' + props.product.content.title + ' from kodansha'}
                isOnSale={props.product.content?.isOnSale}
            />
        );
    }


    if (linkTo === undefined) {
        return (<div className={'KodanshaWheelItem KodanshaWheelItem-no-hover'}
                     aria-label={'item in the wheel' + props.product.content.title}>
            <div className={innerBorderClass}>
                <div className={imageClass} aria-label={'poster wrapper for' + props.product.content.title}>
                    {getProductPoster()}
                </div>
            </div>

            <div className={'ItemTitle'} aria-label={'title for ' + getTitle(props?.product)}>{getTitle(props?.product)}</div>

            <div className={'KodanshaWheelItem-reader'}>
                <KodanshaUnderlinedText text={props.cta?.text ?? ''} aria-label={'go to reader for ' + getTitle(props?.product)} />
            </div>

        </div>);
    }

//TODO: READER uses readable url
    return (<Link to={linkTo} className={`KodanshaWheelItem`}
                  aria-label={'item in the wheel ' + props.product.content.title}>
        <div className={innerBorderClass}>
            <div className={imageClass}
                 aria-label={'poster wrapper for ' + props.product.content.title}
                 onClick={() => {
                     // navigateToProductPage();
                 }}>

                {props.product.type === 'product' ?
                    <ProductPoster preloadImage={false} ratio={props.ratio ?? 125} src={props.product.content.thumbnails[0]?.url}
                                   hover={!!linkTo}
                                   isOnSale={props.product.content?.variants && props.product.content?.variants[0]?.isOnSale}
                                   alt={'product cover for ' + props.product.content.title + ' from kodansha'} /> :
                    <SeriesPoster preloadImage={false} ratio={props.ratio ?? 140} src={props.product.content.thumbnails[0]?.url}
                                  color={props.product.content.thumbnails[0]?.color}
                                  s={{width: 240, aspectRatio: 1.25}}
                                  m={{width:162, aspectRatio: 1.25}}
                                  l={{width: 212, aspectRatio: 1.25}}
                                  xl={{width: 338, aspectRatio: 1.25}}
                                  isOnSale={props.product.content?.isOnSale}
                                  alt={'series cover for ' + props.product.content.title + ' from kodansha'} />}

                {/*<img className={'Item-Image'} src={props.product.content.thumbnails[0].url} />*/}
                {/*<div*/}
                {/*    style={{ backgroundColor: props.product.content.thumbnails[0].url.includes('kodansha_placeholder') ? BlueColorForNotImageFound() : props.product.type !== 'product' && getRandomColor() }}*/}
                {/*    className='colorize'></div>*/}
            </div>
        </div>
        <div className={'ItemTitle'}
             aria-label={'title for ' + getTitle(props?.product)}
             onClick={() => {
                 // navigateToProductPage();
             }}>{getTitle(props?.product)}</div>

        {props.cta?.text && (<Link to={{
            pathname: props.cta?.readableCTA ?? readerReadableUrlOrDefault({id:props.cta?.id ?? props.product?.content?.id, seriesReadableUrl:props.product?.content?.seriesReadableUrl, volumeNumber:props.product?.content?.volumeNumber, chapterNumber:props.product?.content?.chapterNumber}),
            state: { returnPath: history.location.pathname },
        }}
                                   className={'KodanshaWheelItem-reader'}
                                   onClick={e => e.stopPropagation()}
                                   aria-label={'item in the wheel ' + props.product.content.title}>
            <KodanshaUnderlinedText text={props.cta?.text ?? ''}
                                    aria-label={'go to reader for ' + getTitle(props?.product)}
                // onClick={(e) => {
                // e.stopPropagation();
                // history.push('/reader/' + props.cta.id,
                //     { returnPath: history.location.pathname });
                // }}
            />
        </Link>)}
    </Link>);
}

export default React.memo(KodanshaWheelItem);
